<script setup lang="ts">
import { RouterView } from 'vue-router'
import Spinner from './Components/Spinner.vue'
</script>

<template>
    <main class="flex min-h-screen flex-col lg:mx-auto lg:max-w-xl">
        <RouterView v-slot="{ Component, route }">
            <template v-if="Component">
                <Suspense timeout="0">
                    <component :is="Component" :key="route.path" />

                    <template #fallback>
                        <div class="flex flex-1 items-center justify-center bg-white lg:my-8">
                            <Spinner />
                        </div>
                    </template>
                </Suspense>
            </template>
        </RouterView>
    </main>
</template>
